<template>
    <div id="container">
        <SkipToContent/>
        <template v-if="!pageNotFound && !authFailed">
            <OfflineAlert v-if="offline" />
            <!--<keep-alive>-->
                <router-view class="router-content"/>
            <!--</keep-alive>-->
        </template>
        <PageNotFound v-if="pageNotFound" />
        <Communicates />
        <!-- <Tooltip /> -->
        <transition name="overlay-fade">
            <div class="overlay" v-if="isRefreshing"></div>
        </transition>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { mapActions, mapGetters } from 'vuex';
import Communicates from '@/components/Communicates.vue';
import OfflineAlert from '@/components/OfflineAlert.vue';
import locale from '@/mixins/locale'
import progress from '@/mixins/progress';
import SkipToContent from '@/components/SkipToContent.vue';
import { useDataRefresh } from '@/composables/useDataRefresh.js'
import { hideAllPoppers } from 'floating-vue'
import { redirect } from '@/services/returnPath.ts'

export default {
    name: 'App',
    setup () {
        const { isRefreshing } = useDataRefresh()

        return {
            isRefreshing
        }
    },
    mixins: [
        locale,
        progress
    ],
    components: {
        SkipToContent,
        OfflineAlert,
        Communicates,
        PageNotFound: defineAsyncComponent(
            () => import('@/views/404/Index.vue'))
    },
    computed: {
        ...mapGetters({
            config: 'config',
            pageNotFound: 'pageNotFound',
            authFailed: 'authFailed',
            offline: 'offline'
        })
    },
    methods: {
        ...mapActions({
            allowAnalytics: 'allowAnalytics',
            disallowAnalytics: 'disallowAnalytics',
            pushMessage: 'messages/push'
        }),
        installCookieHub() {
            if (!this.config.cookies_notice) {
                return
            }

            const cpm = {
                onAllow: (category) => {
                    if (category === 'analytics') {
                    // FIXME
                    }
                },
                onRevoke: (category) => {
                    if (category === 'analytics') {
                    // FIXME
                    }
                }
            };
            (function(document, window, cpm) {
                const element = document.createElement('script')
                element.async = true
                element.src = 'https://cookiehub.net/c2/8dd6ff3d.js';
                element.onload = () => {
                    window.cookiehub.load(cpm)
                }
                document.head.appendChild(element);
            })(document, window, cpm);
        },
    },
    created() {
        const onOnline = () => {
            this.pushMessage(this.$t('communicates.online'))
        }

        const onOffline = () => {
            this.pushMessage(this.$t('communicates.offline'))
        }

        if (!navigator.onLine) {
            onOffline()
        }

        window.addEventListener('offline', onOffline);
        window.addEventListener('online', onOnline);

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                hideAllPoppers()
            }
        })
    },
    mounted() {
        this.setDocumentLang()
        this.installCookieHub()
        redirect()
    }
}
</script>

<style lang="scss">
@use '@/assets/sass/fonts.scss';
@use '@/assets/sass/a11y.scss';

html, body {
    margin: 0;
    padding: 0;
    font-family: Avenir, Open Sans,ITC Franklin Gothic,Helvetica Neue,helvetica,sans-serif;
    font-weight: 400;
    color: $textColor2;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%; // important for footer

    @include highContrast {
        background-color: Canvas;
        color: CanvasText;
    }
}

pre {
    white-space: pre-wrap;
}

input[type="search"] {
   -webkit-appearance: none;
}

body {
    overflow-y: scroll;

    @include tooltip;

    // important for footer
    #app {
        min-height: 100%;
        position: relative;
    }

    .overlay {
        z-index: 99999;
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.3);
    }

    .overlay-fade-enter-active, .overlay-fade-leave-active {
        transition: background-color .3s;
    }
    .overlay-fade-enter, .overlay-fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        background-color: rgba(0, 0, 0, 0);
    }

    &.scroll-disabled {
        overflow: hidden;
    }
}
</style>
